'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventRelayPropType = exports.makeEventRelay = undefined;

var _react = require('react');

var makeEventRelay = exports.makeEventRelay = function makeEventRelay() {
  var listeners = [];
  var wrappedHandler = void 0;

  var handle = function handle(evt) {
    if (typeof wrappedHandler === 'function') wrappedHandler(evt);
    listeners.forEach(function (listener) {
      return listener(evt);
    });
  };

  return {
    getHandle: function getHandle(handler) {
      wrappedHandler = handler;
      return handle;
    },
    subscribe: function subscribe(listener) {
      return listeners.push(listener);
    },
    unsubscribe: function unsubscribe(listener) {
      return listeners.splice(listeners.indexOf(listener), 1);
    }
  };
};

var eventRelayPropType = exports.eventRelayPropType = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/core/EventRelay.js
// module id = 271
// module chunks = 3 4 5